import { ColumnsType } from "antd/es/table";
import { IPaddleProduct } from "../../redux/types";
import { ActionRenderer } from "./actionRenderer";
import { ProductEditionRenderer } from "./productEditionRenderer";
import { DateRenderer } from "./dateRenderer";
import { Tag } from "antd";

export const getPaddleProductColumns = (): ColumnsType<IPaddleProduct> => [
  {
    title: "Product Name",
    dataIndex: "name",
    key: "name",
    width: 200,
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    width: 250,
    ellipsis: true,
  },
  {
    title: "Product Edition",
    dataIndex: "productEdition",
    key: "productEdition",
    width: 320,
    render: (value: string) => <ProductEditionRenderer value={value} />,
  },
  {
    title: "Prices",
    key: "prices",
    width: 180,
    render: (_: any, record: IPaddleProduct) => {
      const subscriptionCount = record.prices?.filter((p) => p.priceType === "subscription").length || 0;
      const addonCount = record.prices?.filter((p) => p.priceType === "addon").length || 0;
      
      return (
        <div>
          {subscriptionCount > 0 && <Tag color="green">{subscriptionCount} Subscription</Tag>}
          {addonCount > 0 && <Tag color="orange">{addonCount} Add-on</Tag>}
        </div>
      );
    },
  },
  {
    title: "Product ID",
    dataIndex: "productId",
    key: "productId",
    width: 200,
    ellipsis: true,
    render: (id: string) => (
      <span style={{ fontFamily: "monospace", fontSize: "12px" }}>{id}</span>
    ),
  },
  {
    title: "Created",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 150,
    render: (value: string) => DateRenderer(value),
    sorter: (a, b) => 
      new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
  },
  {
    title: "Actions",
    key: "actions",
    width: 400,
    render: (_: any, record: IPaddleProduct) => <ActionRenderer record={record} />,
  },
];

